import { Box, Container, Typography, Stack } from '@mui/material';
import { WHY_BADGES } from '../data/constants';
import { GOLD, GOLDF, DARK } from '../theme/theme';
import ScrollReveal from './ScrollReveal';

export default function TrustBadges() {
  return (
    <Box id="about" sx={{
      scrollMarginTop: '117px',
      bgcolor: '#f8f6f0',
      py: { xs: 5, md: 6 }, px: '5%',
      borderTop: `3px solid ${GOLD}`,
      borderBottom: '1px solid rgba(0,0,0,0.07)',
    }}>
      <Typography sx={{
        textAlign: 'center', color: '#8a6000',
        fontFamily: "'Cinzel',Georgia,serif",
        fontWeight: 700, fontSize: '12px', letterSpacing: '0.28em',
        textTransform: 'uppercase', mb: 4,
      }}>
        — WHY CHOOSE ELARIS ESTATES? —
      </Typography>
      <Container maxWidth="lg">
        <Stack sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2,1fr)', sm: 'repeat(3,1fr)', md: 'repeat(5,1fr)' }, gap: 3, justifyItems: 'center' }}>
          {WHY_BADGES.map(({ emoji, label }, i) => (
            <ScrollReveal key={label} delay={i * 90}>
              <Box sx={{ textAlign: 'center', transition: 'transform 0.22s', '&:hover': { transform: 'translateY(-4px)' } }}>
                <Box sx={{
                  width: 68, height: 68, borderRadius: '50%',
                  border: `2px solid ${GOLD}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  bgcolor: 'rgba(184,134,11,0.08)',
                  mx: 'auto', mb: 1.5, fontSize: '28px',
                  boxShadow: '0 2px 12px rgba(184,134,11,0.15)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': { transform: 'scale(1.08) rotate(-4deg)', boxShadow: '0 6px 20px rgba(184,134,11,0.30)' },
                }}>
                  {emoji}
                </Box>
                <Typography sx={{ color: '#3a2800', fontSize: '12px', fontWeight: 500, lineHeight: 1.6, whiteSpace: 'pre-line' }}>{label}</Typography>
              </Box>
            </ScrollReveal>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
